import moment from 'moment'
import { SESSION_LOCALE } from 'utils/constants'
import { getCurrentLocaleSymbols } from 'utils/functions'

// locales
import 'moment/locale/pt-br'

function getCurrentLocale () {
  const locale = localStorage.getItem(SESSION_LOCALE)
  return getCurrentLocaleSymbols(locale).lang
}

moment.locale(getCurrentLocale())

export default moment
